import { BeeswaxReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import { MAP_SCALES } from './geo';
import { IMPRESSION_TYPES } from './reporting';

// digital channel - placement type
export const CTV_DEVICE = 'Connected TV';

export const GOOGLE_DEVICE_LABELS = {
  VIDEO_LABEL: 'Video',
};

export const PRODUCTS_LABELS = {
  GOLD: 'Gold',
  SILVER: 'Silver',
  BRONZE: 'Bronze',
};

export const OMNICHANNEL_REPORT_FIELDS = {
  [IMPRESSION_TYPES.DATE]: 'dateData',
  [IMPRESSION_TYPES.CHANNEL]: 'channelData',
  [IMPRESSION_TYPES.DEVICE]: 'deviceData',
  [IMPRESSION_TYPES.ADVERTISER]: 'advertiserData',
  [IMPRESSION_TYPES.CAMPAIGN]: 'campaignNameData',
  [IMPRESSION_TYPES.PLACEMENT]: 'placementData',
  [IMPRESSION_TYPES.CREATIVE]: 'creativeData',
  [IMPRESSION_TYPES.PUBLISHER]: 'publisherNameData',
  [IMPRESSION_TYPES.DAYS_OF_WEEK]: 'dayOfWeekData',
  [IMPRESSION_TYPES.DAYPART]: 'dayTimeData',
  [IMPRESSION_TYPES.DEALS]: 'dealsData',
  [IMPRESSION_TYPES.AUDIENCE]: 'audienceData',
  [IMPRESSION_TYPES.PIXEL]: 'pixelData',
  [MAP_SCALES.STATE]: 'stateData',
  [MAP_SCALES.DMA]: 'dmaData',
  [MAP_SCALES.ZIP]: 'zipData',
  [MAP_SCALES.COUNTY]: 'countyData',
  [MAP_SCALES.CITY]: 'cityData',
  [MAP_SCALES.CONGRESSIONAL_DISTRICTS]: 'congressionalDistrictsData',
};

export const OMNICHANNEL_FIELD_MAPPING = {
  [MAP_SCALES.STATE]: IMPRESSION_TYPES.GEO_STATE_VALUE,
  [MAP_SCALES.DMA]: IMPRESSION_TYPES.GEO_DMA_VALUE,
  [MAP_SCALES.ZIP]: IMPRESSION_TYPES.GEO_ZIP_VALUE,
  [MAP_SCALES.COUNTY]: IMPRESSION_TYPES.GEO_COUNTY_VALUE,
  [MAP_SCALES.CONGRESSIONAL_DISTRICTS]: IMPRESSION_TYPES.GEO_CONGRESSIONAL_DISTRICTS_VALUE,
  [MAP_SCALES.CITY]: IMPRESSION_TYPES.CITY,
  [IMPRESSION_TYPES.ADVERTISER]: BeeswaxReportProperties.ADVERTISER_NAME,
  [IMPRESSION_TYPES.PIXEL]: BeeswaxReportProperties.EVENT_NAME,
  [IMPRESSION_TYPES.DAYS_OF_WEEK]: BeeswaxReportProperties.DAY_OF_WEEK,
};
